import axios from 'axios'
import { auth, USE_FIREBASE } from './firebase'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || ''
})

// Attach Firebase ID token to every request when the user is signed in
api.interceptors.request.use(async (config) => {
  if (USE_FIREBASE && auth?.currentUser) {
    try {
      const token = await auth.currentUser.getIdToken()
      config.headers.Authorization = `Bearer ${token}`
    } catch {
      // Token fetch failed — request proceeds without auth header
    }
  }
  return config
})

export default api
